import { SharedModule } from './../../shared/shared.module';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '@angular/material';
import { ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ServiceComponent } from 'app/admin/services/service.component';
import { ServiceService } from 'app/admin/services/service.service';
import { AddServiceComponent } from 'app/admin/services/addservice/add-service.component';

import {
    AutoCompleteModule,
    DataTableModule,
    ConfirmDialogModule
} from 'primeng/primeng';

@NgModule({
    declarations: [ServiceComponent, AddServiceComponent],
    imports: [
        MaterialModule.forRoot(),
        ReactiveFormsModule,
        BrowserModule,
        FormsModule,
        DataTableModule,
        FlexLayoutModule,
        AutoCompleteModule,
        ConfirmDialogModule,
        SharedModule
    ],
    providers: [
        ServiceService
    ],
    entryComponents: [
        ServiceComponent,
        AddServiceComponent
    ]

})

/**
 * Main module for the admin service management.
 *
 * @author mohit.khurana@vernuso.com (Mohit Khurana)
*/

export class ServiceModule { }





// WEBPACK FOOTER //
// ./src/app/admin/services/service.module.ts